// extracted by mini-css-extract-plugin
export default {"container":"search_container__FBB9I","right":"search_right__Qwatl","left":"search_left__VzG6x","input":"search_input__C0Oo1"};